export default __webpack_public_path__ + "8098252f28e93069c75d6010d3ac6bc1.svg";